<template>
  <v-card class="mt-4">
    <v-card-text>
      <v-list density="compact">
        <v-list-item>
          <template #prepend><v-icon icon="mdi-wifi" size="small" /></template>
          <v-list-item-title class="text-wrap">
            En ligne pour la dernière fois {{ humanizeDate(device.last_seen) }}
            <span class="text-caption text-medium-emphasis font-italic">{{ formatDate(device.last_seen) }}</span>
          </v-list-item-title>
        </v-list-item>
        <v-list-item>
          <template #prepend><v-icon icon="mdi-chip" size="small" /></template>
          <v-list-item-title class="text-wrap">Version : {{ device.firmware_version }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
  import type { Device } from '@/model/device.ts'
  import { formatDate, humanizeDate } from '@/utils/date.utils.ts'

  defineProps<{
    device: Device
  }>()
</script>
